

.fdi#wizard{
  .noPointerEvents{
    pointer-events: none;
  }

  .grayColor{
    color: #ececec;
  }

  .hide{
    display: none;
  }

  .titleContainer{
    .title{
      display: flex;
      justify-content: center;
    }
  }

  .searchInputContainer{
    padding: 15px;
  }

  .question{
    .titleContainer{
      .text1{
        font-size: 20px;
        display: flex;
        justify-content: center;
      }
      .text2{
        color: #929292;
        font-size: 12px;
        display: flex;
        justify-content: center;
      }
    }

    .customAnswerContainer{
      display: flex;
      justify-content: center;
      padding: 2px;

      div{
        margin: 0 10px;
      }

      .addCustomAnswerButton{
        display:inline-flex;
        align-items: center;
        padding: 7px;
        cursor: pointer;
        border: solid 1px #ccc;
        margin-left: 5px;
      }
    }
    .content{
      padding: 15px;

      .multiSelect{
        width: 100%;
        max-width: unset;
        font-size: 20px;
        overflow-y: scroll;
        max-height: 100px;
        border: solid 1px #ccc;
        padding: 0;

        &:hover{
          color: unset;
        }

        .option{
          padding: 2px;
          cursor: pointer;
          &:hover{
            background: aliceblue;
          }
        }

      }

      .radioOptions{
        display: flex;
        justify-content: center;
      }

      .tools{
        display: flex;
        .tool{
          cursor: pointer;
          padding: 5px;
          border: solid 1px #ccc;
          margin: 5px 5px 5px 0;
          &:hover{
            text-decoration: underline;
          }
        }
      }

      .selectedContainerToggle{
        display: flex;
        justify-content: center;
        font-size: 20px;
        padding: 10px;
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }

      .selectedContainer{
        padding: 15px;
        .selectedAnswer{
          display: flex;
          justify-content: center;
          span{
            &:hover{
              color: #b80000;
              cursor: pointer;
            }
          }
        }
      }
    }
    .navigationContainer{
      display: flex;
      justify-content: center;

      .navButton{
        display:inline-flex;
        height: 30px;
        align-items: center;
        padding: 7px;
        cursor: pointer;
        border: solid 1px #ccc;
        margin-left: 5px;
      }
    }
  }
}
